import {constants} from '@newsela/angelou';
import {css} from 'emotion';

const {ui} = constants.colors;

export const licenseContainer = css({
  display: 'flex',
  width: '100%',
  justifyContent: 'space-between',
  alignItems: 'center',
  margin: '0.6rem 0px',
});

export const productListContainer = css({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  cursor: 'default',
});

export const productList = css({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  alignItems: 'center',
  padding: '16px 24px 8px',
  margin: '8px 0',
  ul: {
    width: '90%',
    listStyle: 'disc',
    backgroundColor: ui.greyExtraLight,
    borderRadius: '8px',
    paddingInlineStart: 0,
    li: {
      listStyleType: 'disc',
    }
  }
});

export const sectionLabel = css({
  textTransform: 'uppercase',
  fontSize: '12px',
  color: ui.greyLight,
});

export const trialDays = css({
  alignSelf: 'flex-end',
  fontSize: '12px',
  paddingRight: '16px',
  color: ui.red,
});
